/** @module */

var Constants = require('./constants');

/**
 * @param {string} interestGroupId
 * @returns {VisitorProfileProvider}
 *        Provides the initial score for the InterestGroup with the given id.
 */
exports.makeInterestGroupProvider = function makeInterestGroupProvider(interestGroupId:string): VisitorProfileProvider {
  return {
    provides: [Constants.INTEREST_GROUPS_PROFILE_PREFIX, interestGroupId, 'score'],
    isAsync: false,
    isLazy: false,

    // Note: This is a means of avoiding reevaluating score providers on client initialization
    // when their scores already have _some_ cached value. We made a decision that any cached
    // score at all is usable immediately (i.e., we don't care about various kinds of possible
    // staleness).
    //
    // InterestGroup scores are NOT sticky in the sense of "once they have a value, that
    // value will likely never change so we needn't recompute it ever". Rather, they're sticky
    // in that "once they have a value, we needn't recompute it during client activation".
    // `isSticky` only concerns itself with the question of whether to re-run on client
    // activation, so it lines up well with our use case here. Regular score refreshes,
    // on the other hand, will happen in an analyticsTracker plugin that will do the
    // necessary work onPageActivation.
    isSticky: true,

    getter: [
      /**
       * @returns {number}
       *        A default score representing a 'neutral' feeling, independent of the
       *        specific InterestGroup.
       */
      function() {
        return Constants.NEUTRAL_SCORE;
      },
    ],
  };
};

